// Configuração das landing pages por serviço.
// Cada entrada é uma landing focada em UM serviço, com narrativa de conversão.

export const SERVICES_CONFIG = {
    apps: {
        slug: "apps",
        eyebrow: "Desenvolvimento de Apps",
        h1: ["Apps mobile que", "as pessoas amam", "usar todo dia."],
        h1Accent: 2, // índice do trecho em verde neon
        subheadline:
            "iOS + Android nativos ou React Native. Do wireframe ao lançamento nas lojas — com performance de flagship, analytics do dia 1 e um squad que assume o resultado.",
        keyword: "app mobile",
        heroImg:
            "https://images.unsplash.com/photo-1551650975-87deedd944c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxhcHAlMjBkZXZlbG9wbWVudCUyMGludGVyZmFjZXxlbnwwfHx8fDE3ODQ3MjkzNDV8MA&ixlib=rb-4.1.0&q=85",
        proofs: [
            { k: "+80", v: "apps entregues" },
            { k: "4.7★", v: "média nas lojas" },
            { k: "60d", v: "MVP no ar" },
            { k: "-40%", v: "custo vs. fábrica" },
        ],
        benefits: [
            {
                title: "MVP em 60 dias",
                body: "Metodologia dedicada para tirar sua ideia do papel e colocar no bolso do usuário — sem sprints eternos.",
            },
            {
                title: "iOS + Android · 1 código",
                body: "React Native com performance nativa. Você reduz custo e cadência de release cai pela metade.",
            },
            {
                title: "Analytics e crescimento",
                body: "Integração com Firebase, Amplitude e RevenueCat. Você mede retenção, LTV e conversão desde o dia 1.",
            },
            {
                title: "Publicação nas lojas",
                body: "Cuidamos do processo completo na App Store e Play Store — políticas, screenshots, ASO e review.",
            },
        ],
        useCases: [
            "Apps de marketplace e delivery",
            "Fintechs, wallets e investimentos",
            "Healthtech e agendamento clínico",
            "Aplicativos internos para operações",
            "Super-apps corporativos",
            "MVPs para validar startups",
        ],
        faq: [
            {
                q: "Quanto custa desenvolver um app?",
                a: "Um MVP começa em R$ 50k. Apps mais complexos (multi-perfil, pagamentos, integrações) ficam entre R$ 90k e R$ 300k. Fazemos escopo preliminar gratuito em até 24h.",
            },
            {
                q: "Em quanto tempo o app fica pronto?",
                a: "MVPs em 60 a 90 dias. Apps completos em 4 a 6 meses. Trabalhamos em sprints semanais com entregas visíveis.",
            },
            {
                q: "Nativo ou React Native?",
                a: "Depende do produto. Se performance extrema (jogos, câmera, AR) → nativo. Para 90% dos casos, React Native entrega o mesmo com metade do custo.",
            },
            {
                q: "Vocês fazem manutenção após o lançamento?",
                a: "Sim. Oferecemos contratos de evolução mensal com squad dedicado ou sob demanda.",
            },
        ],
    },
    sites: {
        slug: "sites",
        eyebrow: "Sites & Landing Pages",
        h1: ["Sites que", "convertem", "de verdade."],
        h1Accent: 1,
        subheadline:
            "Landing pages de alta conversão, sites institucionais e e-commerces headless. Design de ponta, SEO técnico e Core Web Vitals verdes. Cada pixel serve à sua meta.",
        keyword: "site profissional",
        heroImg:
            "https://images.unsplash.com/photo-1607799279861-4dd421887fb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxhcHAlMjBkZXZlbG9wbWVudCUyMGludGVyZmFjZXxlbnwwfHx8fDE3ODQ3MjkzNDV8MA&ixlib=rb-4.1.0&q=85",
        proofs: [
            { k: "+180%", v: "em conversão média" },
            { k: "<1s", v: "LCP em mobile" },
            { k: "100/100", v: "Lighthouse" },
            { k: "30d", v: "no ar" },
        ],
        benefits: [
            {
                title: "Alta conversão por design",
                body: "Cada seção é desenhada em cima de dados de comportamento — não em cima do achismo do designer.",
            },
            {
                title: "SEO técnico impecável",
                body: "Schema.org, sitemap, robots, meta OG, Core Web Vitals verdes. Você aparece no Google.",
            },
            {
                title: "Stack moderna (Next.js)",
                body: "SSR/ISR, edge functions, CDN global. Velocidade que Google adora e usuário sente.",
            },
            {
                title: "CMS pra você editar",
                body: "Integração com Sanity, Contentful ou Directus. Seu time atualiza conteúdo sem depender de dev.",
            },
        ],
        useCases: [
            "Landing pages de campanha",
            "Sites institucionais premium",
            "E-commerce headless",
            "Portais B2B",
            "Portfólios e sites de marca",
            "Blogs / journals corporativos",
        ],
        faq: [
            {
                q: "Quanto custa um site profissional?",
                a: "Landing pages a partir de R$ 12k. Sites institucionais a partir de R$ 25k. E-commerces a partir de R$ 60k.",
            },
            {
                q: "Em quantos dias fica pronto?",
                a: "Landing pages: 15–30 dias. Institucionais: 30–60 dias. E-commerce: 60–120 dias.",
            },
            {
                q: "Vocês fazem SEO?",
                a: "SEO técnico está incluso. SEO de conteúdo (produção de artigos, link building) é adicional e conectamos com parceiros.",
            },
            {
                q: "Posso editar sozinho depois?",
                a: "Sim — implantamos CMS que qualquer pessoa do time consegue usar. Zero código.",
            },
        ],
    },
    ia: {
        slug: "ia",
        eyebrow: "Inteligência Artificial",
        h1: ["IA que devolve", "horas do seu", "time todo dia."],
        h1Accent: 2,
        subheadline:
            "Chatbots, copilots internos, agentes com memória e integrações com GPT, Claude e Gemini. Casos reais, ROI mensurável, sem hype vazio.",
        keyword: "inteligência artificial",
        heroImg:
            "https://images.pexels.com/photos/28494632/pexels-photo-28494632.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        proofs: [
            { k: "40h/mês", v: "economizadas por usuário" },
            { k: "GPT-5.2", v: "Claude · Gemini" },
            { k: "RAG", v: "sobre seus dados" },
            { k: "R$1", v: "de custo médio/consulta" },
        ],
        benefits: [
            {
                title: "Agentes com contexto real",
                body: "RAG sobre sua base de conhecimento (documentos, ERP, CRM). O agente responde com fatos, não alucinações.",
            },
            {
                title: "Copilots internos",
                body: "Automatize tarefas repetitivas do seu time — respostas de e-mail, resumos, geração de relatórios.",
            },
            {
                title: "Multi-modelo",
                body: "Escolhemos o LLM certo pra cada caso (GPT, Claude, Gemini, Llama) — otimizando custo e qualidade.",
            },
            {
                title: "ROI mensurável",
                body: "Cada implementação vem com dashboard mostrando economia real de horas e dinheiro.",
            },
        ],
        useCases: [
            "Chatbots de atendimento",
            "Copilots para equipes comerciais",
            "Sumarização de documentos",
            "Extração de dados de PDFs",
            "Análise de sentimento em reviews",
            "Assistentes internos com RAG",
        ],
        faq: [
            {
                q: "Vale a pena investir em IA agora?",
                a: "Sim — se você tem uma tarefa repetitiva, um gargalo de atendimento ou volume de documentos. Se é só hype, não vale.",
            },
            {
                q: "A IA vai substituir meu time?",
                a: "Não. Ela devolve horas para o seu time focar no que é estratégico. Copilots amplificam, não substituem.",
            },
            {
                q: "E os dados sensíveis da minha empresa?",
                a: "Trabalhamos com APIs enterprise (sem treino do modelo) ou modelos self-hosted quando LGPD exige.",
            },
            {
                q: "Quanto custa manter uma IA em produção?",
                a: "Custo de tokens fica em geral entre R$500 e R$5.000/mês dependendo do volume. Sempre com dashboard de consumo em tempo real.",
            },
        ],
    },
    automacao: {
        slug: "automacao",
        eyebrow: "Automação & Integrações",
        h1: ["Automatize o", "chato. Foque no", "que importa."],
        h1Accent: 2,
        subheadline:
            "RPA, workflows e integrações entre ERPs, CRMs, planilhas e APIs. Elimine 40h/mês de trabalho manual do seu time — e capriche onde a máquina não chega.",
        keyword: "automação de processos",
        heroImg:
            "https://images.unsplash.com/photo-1760344594784-60ff14035eb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxncmVlbiUyMHRlY2glMjBhYnN0cmFjdHxlbnwwfHx8fDE3ODQ3MjkzNDR8MA&ixlib=rb-4.1.0&q=85",
        proofs: [
            { k: "40h/mês", v: "economizadas" },
            { k: "-62%", v: "tempo de cotação" },
            { k: "n8n", v: "Zapier · Make · APIs" },
            { k: "45d", v: "payback médio" },
        ],
        benefits: [
            {
                title: "Mapeamento de processos",
                body: "Sentamos com o seu time, identificamos os gargalos e escolhemos o que vale automatizar.",
            },
            {
                title: "Integrações sob medida",
                body: "Conectamos ERPs, CRMs, planilhas, WhatsApp, e-mail, Google Workspace e sistemas legados.",
            },
            {
                title: "Workflows visuais",
                body: "n8n, Zapier ou Make quando cabe. Código Python/Node quando o caso pede.",
            },
            {
                title: "Dashboard de horas salvas",
                body: "Você vê em tempo real quanto tempo o seu time recuperou — em horas e em R$.",
            },
        ],
        useCases: [
            "Fluxos financeiros e conciliação",
            "Cotação e emissão automática",
            "Onboarding de clientes",
            "Sincronização entre sistemas",
            "Envio de notificações",
            "Extração de dados de sites",
        ],
        faq: [
            {
                q: "Vale a pena automatizar meu processo?",
                a: "Se ele é repetitivo e consome mais de 5h/semana do time, quase sempre sim. Fazemos ROI grátis em até 48h.",
            },
            {
                q: "Preciso ter sistema para automatizar?",
                a: "Não. Automatizamos até planilhas, e-mails e mensagens de WhatsApp. Se tem regra, tem automação.",
            },
            {
                q: "Quem mantém depois?",
                a: "Você tem duas opções: (1) treinamos seu time; (2) contrato de manutenção mensal conosco.",
            },
            {
                q: "Automação substitui pessoas?",
                a: "Não. Elimina o trabalho braçal repetitivo e libera as pessoas para o que gera valor.",
            },
        ],
    },
};

export const SERVICE_SLUGS = Object.keys(SERVICES_CONFIG);
